const reducer = (state, { type, payload }) => {
	// console.log('reducer:', type, payload);
	// console.log('reducer:'+type);
	switch (type) {
		  case 'SET_STEP':
        return {
          ...state,
          step: payload,
          loading: false,
          message: undefined,
          requireCheck: false,
          otpStatus: undefined,
          error: undefined,
        }
      
		  case 'SET_STATE_DATA':
        return {
          ...state,
          ...payload,
        }
        
       case 'SET_PROFILE_PART':
        return {
          ...state,
          profile: state.profile? {...state.profile, ...payload} : payload,
        }
      
      case 'LOADING':
        return {
          ...state,
          loading: true,
          message: undefined,
        }
      
      case 'LOADED':
        return {
          ...state,
          loading: false,
          message: undefined,
        }
      
      case 'LOAD_FAILED':
        return {
          ...state,
          loading: false,
          message: payload,
        }
      
      default:
        return state;
  }
}
export default reducer;